import script from "./PlanMejoramientoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanMejoramientoView.vue?vue&type=script&setup=true&lang=ts"

import "./PlanMejoramientoView.vue?vue&type=style&index=0&id=cca24f04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca24f04"]])

export default __exports__